/*
 * IMPORTS
 */
import { produce } from 'immer' // Npm: Immer library.


/*
 * INITIAL STATE
 */
export const _initialState = {
  // Remote System Data (DB Server)
  'remote': {
    'data': null,
    'error': null,
    'loading': true
  },
  // Local System Data (Node Server)
  'local': {
    'data': null,
    'error': null,
    'loading': true
  }
}


/*
 * OBJECTS
 */
const _SystemInfoReducer = (__prevState = _initialState, action) =>
  // Return the new state based on the action type
  produce(__prevState, __d => {
    /*
     * Switch case for handling actions on
     * SystemInfo store.
     */
    switch (action.type) {
      // Remote System (DB Server) Actions
      case 'SYSTEMINFO_REMOTE_UPDATE':
        // Update remote data
        __d.remote.data = action.payload
        __d.remote.error = null
        __d.remote.loading = false
        return

      case 'SYSTEMINFO_REMOTE_ERROR':
        // Set remote error
        __d.remote.error = action.payload
        __d.remote.loading = false
        return

      case 'SYSTEMINFO_REMOTE_LOADING':
        // Set remote loading state
        __d.remote.loading = action.payload
        return

      // Local System (Node Server) Actions
      case 'SYSTEMINFO_LOCAL_UPDATE':
        // Update local data
        __d.local.data = action.payload
        __d.local.error = null
        __d.local.loading = false
        return

      case 'SYSTEMINFO_LOCAL_ERROR':
        // Set local error
        __d.local.error = action.payload
        __d.local.loading = false
        return

      case 'SYSTEMINFO_LOCAL_LOADING':
        // Set local loading state
        __d.local.loading = action.payload
        return

      // Clear Actions
      case 'SYSTEMINFO_CLEAR':
        // Reset the draft state to initial state
        return _initialState

      case 'SYSTEMINFO_REMOTE_CLEAR':
        // Clear only remote data
        __d.remote = _initialState.remote
        return

      case 'SYSTEMINFO_LOCAL_CLEAR':
        // Clear only local data
        __d.local = _initialState.local
        return

      default:
        // Do nothing for other action types
        return __prevState
    }
  })


/*
 * EXPORTS
 */
export default _SystemInfoReducer
